export default {
  userInfo: null,
  channel: '',
  flowNo: ''
}
